import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PreviewGate
 * ===========
 * Wraps a portal/dashboard that is not yet backed by real data. Shows a clear
 * "Coming soon" interstitial so we never present sample data as if it were
 * live. The user can either go back or explicitly continue into a labelled
 * preview. Once inside, a persistent banner keeps the preview status visible.
 */
export default function PreviewGate({ title = 'This area is coming soon', children }) {
  const [entered, setEntered] = useState(false);
  const navigate = useNavigate();

  if (entered) {
    return (
      <div style={{ position: 'relative' }}>
        <div
          role="status"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 3000,
            background: '#7a5c00',
            color: '#fff',
            padding: '8px 16px',
            fontSize: 14,
            textAlign: 'center',
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Preview only — this area shows sample data and is not yet live.
        </div>
        {children}
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#121212',
        color: '#fff',
        fontFamily: '"Poppins", sans-serif',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🚧</div>
        <h1 style={{ fontSize: 28, marginBottom: 12 }}>{title}</h1>
        <p style={{ opacity: 0.8, lineHeight: 1.6, marginBottom: 28 }}>
          We are still building this experience. You can continue into an early
          preview, but the data shown is sample data and does not reflect your
          real account yet.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '12px 22px',
              borderRadius: 8,
              border: '1px solid #444',
              background: 'transparent',
              color: '#fff',
              cursor: 'pointer',
              fontSize: 15,
            }}
          >
            Back to home
          </button>
          <button
            onClick={() => setEntered(true)}
            style={{
              padding: '12px 22px',
              borderRadius: 8,
              border: 'none',
              background: '#4c8bf5',
              color: '#fff',
              cursor: 'pointer',
              fontSize: 15,
              fontWeight: 600,
            }}
          >
            Continue to preview
          </button>
        </div>
      </div>
    </div>
  );
}
